export default function Rust_Intro() {
  return (
    <div>
      <h1>Rust_Intro Component</h1>
      <p>This is the Rust_Intro page.</p>
    </div>
  );
}
